import { render, staticRenderFns } from "./bottomNavBar.vue?vue&type=template&id=1b51aca5&"
import script from "./bottomNavBar.vue?vue&type=script&lang=js&"
export * from "./bottomNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports